import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ITestsStrings extends LocalizedStringsMethods {
    lsClearFiltersTxt: string;
    lsNameTxt: string;
    lsHomeTxt: string;
    lsTestsTxt: string;
    lsViewTestsTxt: string;
    lsNoFilterTxt: string;
    lsOrgsTxt: string;      
    lsEditTxt: string;
    lsOkTxt: string;    
    lsPrintTxt: string;
    lsTotalTestTxt: string;
    lsBaselineTxt: string;
    lsYesTxt: string;
    lsNoTxt: string;
    lsConcussionTxt: string;
    lsDateTimeTxt: string;
    lsScoreTypeTxt: string;
    lsTestTagTxt: string;
    lsScoreTxt: string;
    lsEyeTxt: string;
    lsActionTxt: string;
    lsViewtxt: string;
    lsDwnldTxt: string;
    lsStartDateTxt: string;
    lsEndDateTxt: string;
    lsShareTestTxt: string;
    lsDwbldSuccessTxt: string;
    lsShareTxt: string;
    lsTestShareSuccess: string;
    lsTestShareFailedTxt: string;
    lsTestFilterHdrTxt: string;
    lsFilterTxt: string;
    lsDownloadProfileTxt: string;
    lsEditTestTxt: string;
    lsSaveTxt: string;
    lsCSVTxt: string;
    lsImpairedTxt: string;
}

let strings: ITestsStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsDownloadProfileTxt: 'Download Profile List',
        lsDownloadTextTxt: 'Download Test List',
        lsTestFilterHdrTxt: 'Test List Filter',
        lsClearFiltersTxt: 'Clear Filters',
        lsViewTestsTxt: 'View Tests',
        lsNoFilterTxt: 'No filters applied',
        lsNameTxt: 'First name',
        lsTestsTxt: 'Tests',
        lsTotalTestTxt: 'Total {0} tests',
        lsBaselineTxt: 'Baseline',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',
        lsConcussionTxt: 'Dr Dx Concussion',
        lsDateTimeTxt: 'Date And Time',
        lsScoreTypeTxt: 'Score Type',
        lsTestTagTxt: 'Test Type',
        lsScoreTxt: 'Score',
        lsEyeTxt: 'Eye',
        lsActionTxt: 'Action',
        lsViewtxt: 'View',
        lsHomeTxt: 'Home',
        lsOrgsTxt: 'Organizations',
        lsEditTxt: 'Edit',
        lsDwnldTxt: 'Download',
        lsOkTxt: 'Ok',    
        lsPrintTxt: 'Print',
        lsStartDateTxt: 'Start Date',
        lsEndDateTxt: 'End Date',
        lsShareTestTxt: 'Share Test',
        lsDwbldSuccessTxt: 'Tests downloaded successfully',
        lsShareTxt: 'Share',
        lsTestShareSuccess: 'Tests shared successfully!',
        lsTestShareFailedTxt: 'Tests could not be shared.Please try again!',
        lsFilterTxt: 'Filter',
        lsEditTestTxt: 'Edit Test',
        lsSaveTxt: 'Save',
        lsCSVTxt: 'CSV',
        lsImpairedTxt: 'Poor'
    },
    es: {
        lsDownloadProfileTxt: 'Descargar la lista de perfiles',
        lsDownloadTextTxt: 'Descargar lista de prueba',
        lsTestFilterHdrTxt: 'Filtro de lista de perfil',
        lsClearFiltersTxt: 'Borrar filtros',
        lsNoFilterTxt: 'No se aplicaron filtros',
        lsViewTestsTxt: 'Ver pruebas',
        lsTestsTxt: 'Pruebas',
        lsNameTxt: 'Nombre',
        lsTotalTestTxt: 'Total de {0} pruebas',
        lsBaselineTxt: 'Base',
        lsYesTxt: 'Sí',
        lsNoTxt: 'No',
        lsConcussionTxt: 'Dr Dx Concussion',
        lsDateTimeTxt: 'Fecha y hora',
        lsScoreTypeTxt: 'Tipo de puntuación',
        lsTestTagTxt: 'Tipo de prueba',
        lsScoreTxt: 'Puntuación',
        lsEyeTxt: 'Eye', 
        lsViewtxt: 'Ver',
        lsHomeTxt: 'Casa',
        lsOrgsTxt: 'Organizaciones',
        lsEditTxt: 'Editar',
        lsActionTxt: 'Acción',
        lsDwnldTxt: 'Descargar',
        lsOkTxt: 'De acuerdo',    
        lsPrintTxt: 'Impresión',
        lsStartDateTxt: 'Fecha de inicio',
        lsEndDateTxt: 'Fecha final',
        lsShareTestTxt: 'Compartir prueba',
        lsDwbldSuccessTxt: 'Pruebas descargadas con éxito',
        lsShareTxt: 'Compartir',
        lsTestShareSuccess: 'Tests shared successfully!',
        lsTestShareFailedTxt: 'Tests could not be shared.Please try again!',
        lsFilterTxt: 'Filtrar',
        lsEditTestTxt: 'Edit Test',
        lsSaveTxt: 'Save',
        lsCSVTxt: 'CSV',
        lsImpairedTxt: 'Poor'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/test/string.test.tsx